import { render, staticRenderFns } from "./companyCamBox.vue?vue&type=template&id=9192ea1c&"
import script from "./companyCamBox.vue?vue&type=script&lang=js&"
export * from "./companyCamBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports